import InsightCard, { InsightProps } from './InsightCard';

const mockInsights: InsightProps[] = [
    {
        type: 'warning',
        title: 'Engagement Drop',
        description: 'Your engagement rate dropped by 15% this week. Check comments for potential issues.',
        actionLabel: 'View Analysis',
        onAction: () => console.log('View Analysis'),
    },
    {
        type: 'achievement',
        title: 'New Milestone!',
        description: 'You reached 10k followers! A new mission is available to celebrate.',
        actionLabel: 'Start Mission',
        onAction: () => console.log('Start Mission'),
    },
    {
        type: 'info',
        title: 'Algorithm Update',
        description: 'TikTok updated trending music weighting. Try using trending sounds in your next post.',
        actionLabel: 'Read More',
        onAction: () => console.log('Read More'),
    },
];

const AlertsInsightsCarousel = () => {
    return (
        <div className="mb-8">
            <div className="flex items-center justify-between mb-3 px-1">
                <h3 className="text-sm font-semibold text-slate-400 uppercase tracking-wider">Updates & Alerts</h3>
            </div>
            
            {/* Horizontal scroll container with improved mobile snapping and padding */}
            <div className="flex gap-4 overflow-x-auto pb-6 -mx-4 px-4 sm:pb-4 sm:mx-0 sm:px-0 snap-x snap-mandatory scrollbar-hide">
                {mockInsights.map((insight, idx) => (
                    <InsightCard key={idx} {...insight} />
                ))}
            </div>
        </div>
    );
};

export default AlertsInsightsCarousel;
